<template>
  
  <div id="mapContainer">
    <h2>Aktuelle Veranstaltungen ({{events.length}})</h2>
    <div class="row">

        <div class="col col-lg-4 col-sm-12 col-12" id="eventsList">
          <ul class="events-map-list">
            <li v-for="(e,i) in events" :key="i">
              <h3>{{ e.name }}</h3>
              <div class="date-info">{{ e.from }} - {{ e.to }}</div>
            </li>
          </ul>


        </div>
        <div class="col col-lg-8  col-sm-12 col-12"  id="mapStage">
          <GmapMap  map-type-id="terrain" :center="mapCenter" :zoom="10" style="width: 100%; height: 65vh" >
            <GmapMarker
                :key="index"
                v-for="(e, index) in events"
                :position="e.lat_lng"
                :clickable="true"
                :draggable="false"
                :title="`${e.name}`"
                @click="openOverlay(e, null)"
            />
          </GmapMap>
        </div>


    </div>


  </div>


</template>

<script>

import axios from 'axios'

export default {

  data(){
    return {
      events: [],
      mapCenter: { lat:52.51847983356812, lng:13.399880811721381 },
    }
  },
  mounted(){
    axios.get("/events/list")
    .then(r => {
      this.events = r.data.markets
    })
  },
  methods: {
    openOverlay(e,y){

    }
  }

}




</script>